import { styled } from 'styled-components'

export const SubTitle = styled.h2`
  font-size: 32px;
  font-family: 'Roboto', sans-serif;
    font-weight: 900;
    line-height: 43px;
    padding: 12px 0 9px 0;
`